import gql from 'graphql-tag';

export default gql`
    mutation DeleteDriver($input: DriverDeleteRequest) {
        deleteDriver(input: $input) {
            errors
        }
    }
`;
